import { render, staticRenderFns } from "./ticketOrganizationDetail.vue?vue&type=template&id=29a360fa&scoped=true&"
import script from "./ticketOrganizationDetail.vue?vue&type=script&lang=js&"
export * from "./ticketOrganizationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ticketOrganizationDetail.vue?vue&type=style&index=0&id=29a360fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a360fa",
  null
  
)

export default component.exports